import Vue from 'vue';
import VueRouter from 'vue-router';

import CreateJobAlert from '@/apps/af-page/001/components/CreateJobAlert';
import UnsubscribeJobAlert from '@/apps/af-page/001/components/UnsubscribeJobAlert';

Vue.use(VueRouter);

const routes = [
    {
        path: '/create-job-alert',
        name: 'createjobalert',
        component: CreateJobAlert,
    },
    {
        path: '/unsubscribe-job-alert',
        name: 'unsubscribejobalert',
        component: UnsubscribeJobAlert,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: `${process.env.BASE_URL}${process.env.NODE_ENV !== 'production' ? 'afpage001' : 'af-page' }`,
    routes,
});

Vue.use(router);

export default router;
